<template>
    <!-- <div class="not-found">
      <h1>404 - Page Not Found</h1>
      <p>Sorry, the page you're looking for doesn't exist.</p>
      <router-link to="/">Go to Home</router-link>
    </div> -->
    <main>
        <div class="container">

            <section class="section error-404 min-vh-100 d-flex flex-column align-items-center justify-content-center">
                <h1>404</h1>
                <h2>La página que estas solicitando no existe.t.</h2>
                <router-link class="btn" to="/">Regresa al inicio</router-link>
                <img :src="image" class="img-fluid py-5" alt="Page Not Found">
                <div class="credits">
                    <!-- All the links in the footer should remain intact. -->
                    <!-- You can delete the links only if you purchased the pro version. -->
                    <!-- Licensing information: https://bootstrapmade.com/license/ -->
                    <!-- Purchase the pro version with working PHP/AJAX contact form: https://bootstrapmade.com/nice-admin-bootstrap-admin-html-template/ -->
                    <!-- Designed by <a href="https://bootstrapmade.com/">BootstrapMade</a> -->
                </div>
            </section>

        </div>
    </main>
</template>

<script>
export default {
    name: "NotFound",

    data() {

        return {

            image: require('@/assets/images/not-found.svg'),
        };
    },
};
</script>

<!-- <style scoped>
.not-found {
    text-align: center;
    padding: 50px;
}

h1 {
    font-size: 2em;
}

p {
    margin-top: 10px;
    font-size: 1.2em;
}

router-link {
    margin-top: 20px;
    display: inline-block;
    padding: 10px;
    background-color: #4CAF50;
    color: white;
    text-decoration: none;
    border-radius: 5px;
}
</style> -->